import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";
import { OPS_ENDPOINTS } from "@constants/endpoints";

const DEFAULT_LIMIT = 10;

/**
 * Every brand, with its denormalised `contract_status`, filterable by it.
 */
const useContractTargets = () => {
    const { axiosInstance, loading } = useAxios({ base: "ops", initialLoader: true, showAlert: false });

    const [rows, setRows] = useState([]);
    const [pagination, setPagination] = useState({ total: 0, page: 1, limit: DEFAULT_LIMIT });
    const [filters, setFilters] = useState({});

    const fetchTargets = async (page = 1, limit = DEFAULT_LIMIT, currentFilters = filters) => {
        try {
            const res = await axiosInstance.get(OPS_ENDPOINTS.BRAND_CONTRACTS, {
                params: { page, limit, ...currentFilters }
            });
            const result = res.data || res;
            const items = result.data || result.items || result.results || [];

            setRows(items);
            setPagination({
                total: result.pagination?.total ?? result.total ?? items.length,
                page : result.pagination?.page ?? result.page ?? page,
                limit: result.pagination?.limit ?? result.limit ?? limit
            });
        } catch {
            setRows([]);
            setPagination({ total: 0, page, limit });
        }
    };

    useEffect(() => {
        fetchTargets(1, pagination.limit, filters);
    }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleFilterChange = (next) => setFilters((prev) => ({ ...prev, ...next }));

    return {
        rows,
        pagination,
        loading,
        filters,
        handleFilterChange,
        handlePageChange   : (limit, page) => fetchTargets(page, limit, filters),
        handlePerRowsChange: (limit) => fetchTargets(1, limit, filters),
        refetch            : () => fetchTargets(pagination.page, pagination.limit, filters)
    };
};

export default useContractTargets;
